import { render, staticRenderFns } from "./xcxText.vue?vue&type=template&id=6f35af70&"
import script from "./xcxText.vue?vue&type=script&lang=js&"
export * from "./xcxText.vue?vue&type=script&lang=js&"
import style0 from "./xcxText.vue?vue&type=style&index=0&id=6f35af70&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports